module.exports = __webpack_public_path__ + "img/tensorflow.5277351d.png";